import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.138 4.724c.921-1.842 1.382-2.763 2.005-3.059a2 2 0 0 1 1.714 0c.623.296 1.084 1.217 2.005 3.06l.36.718c.284.569.426.853.634 1.071.184.193.405.347.65.453.276.12.592.155 1.224.225l.326.036c2.209.246 3.313.369 3.812.878a2 2 0 0 1 .553 1.674c-.098.706-.912 1.462-2.54 2.974l-.345.32c-.556.516-.834.774-.994 1.086a2.001 2.001 0 0 0-.22.893c-.005.352.123.714.377 1.44v0c.83 2.366 1.246 3.549.974 4.24a2 2 0 0 1-1.37 1.209c-.721.182-1.826-.37-4.036-1.475l-.836-.418c-.525-.262-.787-.394-1.062-.445a2.001 2.001 0 0 0-.738 0c-.275.051-.537.183-1.062.445l-.836.418c-2.21 1.105-3.315 1.657-4.035 1.475a2 2 0 0 1-1.371-1.208c-.272-.692.144-1.875.974-4.242v0c.254-.725.382-1.087.378-1.439a2 2 0 0 0-.22-.893c-.161-.312-.44-.57-.995-1.086l-.344-.32C2.49 11.242 1.677 10.486 1.58 9.78a2 2 0 0 1 .552-1.674c.5-.51 1.603-.632 3.812-.878l.326-.036c.632-.07.948-.105 1.224-.225a2 2 0 0 0 .65-.453c.208-.218.35-.502.635-1.071l.359-.719Z"
    />
  </svg>
)
export default SvgComponent
